import { Injectable, ErrorHandler, Injector, inject } from '@angular/core';

import { AggregatedLoggerService } from './aggregated-logger.service';

@Injectable()
export class LogErrorHandler implements ErrorHandler {
  private readonly injector = inject(Injector);

  handleError(error: any): void {
    const logger: AggregatedLoggerService = this.injector.get(AggregatedLoggerService);
    if (logger) {
      logger.error(error);
    }

    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }
  }
}
